import classNames from "classnames";
import {
  Icon,
  type IconName,
} from "../../../../../../../components/Icon/Icon.tsx";
import { PanelSection } from "../../../../../components/Panel/PanelSection.tsx";
import { GENERATION_TYPE_TO_LABEL_AND_ICON } from "../../../../../display.ts";
import { useSelectedAsset } from "../../../../../hooks/useSelectedAsset.ts";
import { ItemSectionDetails } from "../../../../components/SectionDetails.tsx";
import { ContentGenerationParametersDetails } from "./ContentGenerationParametersContent.tsx";

export const GeneralInformationSection = () => {
  const { selectedAsset: asset } = useSelectedAsset();

  if (!asset) return null;

  return (
    <PanelSection title="Info">
      <ItemSectionDetails name="Tool used">
        <InformationHeader
          iconName={
            asset.content.information.generation_parameters?.generation_type
              ? GENERATION_TYPE_TO_LABEL_AND_ICON[
                  asset.content.information.generation_parameters
                    .generation_type
                ].iconName
              : undefined
          }
          label={
            asset.content.information.generation_parameters?.generation_type
              ? GENERATION_TYPE_TO_LABEL_AND_ICON[
                  asset.content.information.generation_parameters
                    .generation_type
                ].label
              : "Not generated"
          }
        />
      </ItemSectionDetails>
      <ItemSectionDetails name="Created">
        <div className={classNames("label-md-default text-primary")}>
          {new Date(asset.created_at).getDate()}/
          {new Date(asset.created_at).getMonth() + 1}/
          {new Date(asset.created_at).getFullYear()}
        </div>
      </ItemSectionDetails>
      <ItemSectionDetails name="Creator">
        <div className="label-md-default flex-fill overflow-auto scrollbar-hide text-primary">
          {asset.content.information.user_email ?? ""}
        </div>
      </ItemSectionDetails>
      {asset.content.width && asset.content.height ? (
        <ItemSectionDetails name="Resolution">
          <div
            className={classNames(
              "label-md-default overflow-x-hidden text-ellipsis text-primary",
            )}
          >
            {asset.content.status === "SUCCEEDED"
              ? `${asset.content.width} x ${asset.content.height}`
              : "Generating"}
          </div>
        </ItemSectionDetails>
      ) : null}
      {asset.content.information.generation_parameters?.generation_type && (
        <ContentGenerationParametersDetails content={asset.content} />
      )}
    </PanelSection>
  );
};

const InformationHeader = ({
  iconName,
  label,
}: {
  iconName?: IconName;
  label: string;
}) => (
  <div className="flex-row items-center gap-100 overflow-hidden">
    {iconName && <Icon name={iconName} size="sm" />}
    <div className={classNames("label-md-default text-ellipsis")}>{label}</div>
  </div>
);
